import { Link } from 'react-router-dom';
import { openSupportChat } from '@/utils/supportChat';

const PRODUCT_LINKS = [
  { label: 'Live Performance', to: '/performance' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Get EA Free', to: '/get-ea' },
  { label: 'FAQ', to: '/faq' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="max-w-shell mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
            {/* Brand */}
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/">
                <img src="/image/foot_logo.png" alt="GoldWarden EA" className="h-20 w-auto" />
              </Link>
              <p className="mt-4 text-sm leading-relaxed text-background-200/85 max-w-xs">
                A free MetaTrader 5 expert advisor built exclusively for XAUUSD. Fully automated,
                risk-controlled and transparent about its live track record.
              </p>
              <button
                type="button"
                onClick={openSupportChat}
                className="mt-5 inline-flex items-center gap-2 rounded-full bg-accent-500 hover:bg-accent-400 px-4 py-2 text-sm font-semibold text-primary-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line text-base" aria-hidden="true"></i>
                Chat with support
              </button>
            </div>

            {/* Product */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Product</h4>
              <ul className="flex flex-col gap-2.5">
                {PRODUCT_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/85 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Account specs */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Runtime Specs</h4>
              <ul className="flex flex-col gap-2.5 text-sm text-background-200/85">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
                  Platform: MetaTrader 5
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
                  Symbol: XAUUSD
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
                  Timeframe: M15
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
                  Recommended VPS: Windows
                </li>
              </ul>
            </div>
          </div>

          {/* Risk disclaimer */}
          <div className="mt-12 rounded-lg border border-background-50/10 bg-background-50/[0.04] p-4 md:p-5">
            <p className="text-xs leading-relaxed text-background-200/70">
              <strong className="text-background-100 font-semibold">Risk warning:</strong> Trading
              leveraged gold (XAUUSD) carries a high level of risk and can result in the loss of all
              your capital. GoldWarden EA is provided free of charge for educational and personal use.
              All performance figures are historical and reflect one live account under its specific
              broker conditions. Past results are not indicative of future performance. Never trade
              money you cannot afford to lose.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-200/70">
              © {year} GoldWarden EA. Free for personal use. Not investment advice.
            </p>
            <p className="text-xs text-background-200/60">
              MetaTrader 5 is a trademark of MetaQuotes Ltd. Not affiliated with any broker.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}